var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_vm.ready && _vm.exchangeOrder ? _c('v-responsive', {
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "tile": "",
      "max-width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--lg"
  }, [_c('span', {
    staticClass: "py-4 pl-4"
  }, [_c('b', [_vm._v("교환결과")])])])], 1), _c('v-card', {
    attrs: {
      "elevation": "0",
      "tile": "",
      "max-width": "100%"
    }
  }, [_c('v-divider'), _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "tit tit--xs"
  }, [_vm._v("모바일 도서교환권 교환")]), _c('div', {
    staticClass: "font-size-16"
  }, [_c('div', [_vm._v("교환·결제가 완료되었습니다.")])])]), _c('v-divider'), _c('pickup-item', {
    attrs: {
      "cart": _vm.exchangeOrder.purchase
    }
  }), _c('v-divider'), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v("총 상품가격")]), _c('v-spacer'), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v(_vm._s(_vm.exchangeOrder.saleAmount.format()) + " 원")])], 1), _c('v-layout', [_c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v("총 배송비")]), _c('v-spacer'), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v(_vm._s(_vm.exchangeOrder.shippingAmount.format()) + " 원")])], 1), _c('v-layout', [_c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v("캐시 사용")]), _c('v-spacer'), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v("- " + _vm._s(_vm.exchangeOrder.cashAmount.format()) + " 원")])], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v("총 주문 금액")]), _c('v-spacer'), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_vm._v(_vm._s(_vm.exchangeOrder.totalAmount.format()) + " 원")])], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('b', [_vm._v("결제 금액")])]), _c('v-spacer'), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.exchangeOrder.paymentAmount.format()) + " 원")])])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs"
  }, [_vm._v("구매자")]), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    staticClass: "mx-n2 mt-n4",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-4 px-2",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v("이름")]), _c('div', {
    staticClass: "font-size-14 black--text"
  }, [_vm._v(_vm._s(_vm.exchangeOrder.buyer.name || "-"))])])]), _c('v-flex', {
    staticClass: "mt-4 px-2",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v("연락처")]), _c('div', {
    staticClass: "font-size-14 black--text"
  }, [_vm._v(_vm._s(_vm.exchangeOrder.buyer.phone || "-"))])])]), _c('v-flex', {
    staticClass: "mt-4 px-2",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v("이메일")]), _c('div', {
    staticClass: "font-size-14 black--text"
  }, [_vm._v(_vm._s(_vm.exchangeOrder.buyer.email || "-"))])])])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs"
  }, [_vm._v("수취인(받는사람)")]), _c('v-card-text', [_c('v-layout', {
    staticClass: "mx-n2 mt-n4",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-4 px-2",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v("이름")]), _c('div', {
    staticClass: "font-size-14 black--text"
  }, [_vm._v(_vm._s(_vm.exchangeOrder.receiver.name || "-"))])])]), _c('v-flex', {
    staticClass: "mt-4 px-2",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v("연락처")]), _c('div', {
    staticClass: "font-size-14 black--text"
  }, [_vm._v(_vm._s(_vm.exchangeOrder.receiver.phone || "-"))])])]), _c('v-flex', {
    staticClass: "mt-4 px-2",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v("이메일")]), _c('div', {
    staticClass: "font-size-14 black--text"
  }, [_vm._v(_vm._s(_vm.exchangeOrder.receiver.email || "-"))])])])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs"
  }, [_vm._v("요청사항")]), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.exchangeOrder.demand || "-") + " ")])], 1), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "x-large": "",
      "color": "white",
      "elevation": "0",
      "to": "/"
    }
  }, [_vm._v("홈으로가기")]), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "x-large": "",
      "color": "primary",
      "elevation": "0",
      "to": "/mypage/shop/purchases"
    }
  }, [_vm._v("주문내역확인")])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }